<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <ref-components-table :mode="'compact'"  :value="[refComponent]" @input="setValue" @onCloseWindow="doClose" />
  </v-dialog>
</template>

<script>
import RefComponentsTable from '@/components/modules/references/refComponentsTable'

export default {
  name: 'prjSelectRefComponentDialog',
  components: { RefComponentsTable },
  props: ['refComponent', 'value'],
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    setValue (val) {
      console.log('prjSelectRefComponentDialog retransmitting event INPUT with value ', val)
      this.$emit('onRefComponentChanged', val.length ? val[0] : null)
      this.doClose()
    },
    doClose () {
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('prjSelectRefComponentDialog mounted with property ', this.refComponent)
  }
}
</script>
